
const LIVE_URL = "https://api.erp.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";
// Use LOCAL_URL for local development; switch to LIVE_URL for production API.
export const MAIN_URL = LIVE_URL;
export const APPLICATION_KEY = "hr";

/** Headers for fetch() calls (axios interceptor does not apply to fetch). */
export function getApiHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (APPLICATION_KEY) {
    headers["X-Application-Key"] = APPLICATION_KEY;
  }
  return headers;
}
